export default {
  oma: {
    fromDate: "Dari Tanggal",
    toDate: "Sampai Tanggal",
    selectDate: "Pilih Tanggal",
    cancel: "BATAL",
    avocadoTreesList: "Daftar Pohon Alpukat",
    addTreesManually: "Tambahkan Lokasi Geolokasi Pohon Secara Manual",
    confirmationTitle: "Konfirmasi",
    confirmationMessage: "Pohon Alpukat telah berhasil ditambahkan/diedit",
    addTreesBulk: "Impor pohon secara massal",
    addNewFarm: "Pilih Peternakan",
    selectFarm: "Pilih Peternakan",
    selectZone: "Pilih Zona",
    treeId: "ID Pohon",
    treeName: "Nama Pohon",
    zoneId: "ID Zona",
    latitude: "Lintang",
    longitude: "Bujur",
    altitude: "Ketinggian",
    timestamp: "timestamp",
    avocadoTrees: "Pohon Alpukat",
    // Kelayakan tanah
    landSuitibility: "Kelayakan Tanah",
    landSuitibilityReport: "Laporan Kelayakan Tanah",
    generateNewReport: "Buat Laporan Baru",
    operatorName: "Nama Operator",
    issueDate: "Tanggal Penerbitan",
    chooseYourLocation: "Pilih Lokasi Anda",
    getLandEvaluation: "Dapatkan evaluasi tanah",
    downloadPdfReport: "Unduh laporan PDF",
    pleaseEnterCoordinateText:
      "Harap masukkan koordinat (bujur dan lintang) lokasi peternakan untuk melihat skornya.",
    noRecordAvailable: "Tidak ada hasil yang tersedia.",
    overallScoreForLand: "Skor Keseluruhan untuk Kelayakan Tanah",
    landEvaluation: "Evaluasi Tanah",
    unsuitable: "Tidak Sesuai",
    marginally: "Marginally",
    suitable: "Sesuai",
    moderately: "Cukup",
    highly: "Sangat Sesuai",
    back: "Kembali",
    search: "Cari",
    showResults: "Tampilkan Hasil",

    // Analisis cuaca
    weatherAnalysisReport: "Laporan Analisis Cuaca",
    weatherAnalysis: "Analisis Cuaca",
    weatherReport: "Laporan Cuaca",
    getWeatherAnalysis: "Dapatkan Analisis Cuaca",
    filterByDate: "Filter berdasarkan Tanggal",
    insertCoordinateText:
      "Masukkan koordinat lokasi peternakan (atau pohon) di atas, atau gunakan peta di bawah untuk menunjukkan lokasi peternakan (atau pohon).",

    addTreeGeolocation: "Tambahkan Geolokasi Pohon",
    editTreeGeolocation: "Edit Geolokasi Pohon",
    plantationDate: "Tanggal Ditanam",
    notes: "Catatan",
    uploadTreeImages: "Unggah Gambar Pohon",
    valueAtTheCoordinatesOfInterest: "Nilai di Koordinat yang Dimaksud",
    "Slope (%)": "Kemiringan (%)",
    "Soil texture (USDA class)": "Tekstur Tanah (kelas USDA)",
    "Coarse fragments (vol%)": "Fragmen Kasar (vol%)",
    Land: "Tanah",
    "Artificial surfaces (type)": "Permukaan Buatan (jenis)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "Jarak ke Jalan Tipe 1 dan 2 (meter)",
    "Soil Chemical Properties": "Sifat Kimia Tanah",
    "Soil Physical Properties": "Sifat Fisik Tanah",
    "Soil organic carbon (%)": "Karbon Organik Tanah (%)",
    "Soil pH": "pH Tanah",
    "Soil salinity (ECe))": "Salinitas Tanah (ECe)",
    "Mean annual temperature (°C)": "Suhu rata-rata tahunan (°C)",
    Weather: "Cuaca",
    "Mean minimum temperature of coldest month (°C)":
      "Suhu minimum rata-rata bulan terdingin (°C)",
    "Mean annual precipitation (mm)": "Curah hujan tahunan rata-rata (mm)",
    avocadoDetailNoUpdates: "Tidak Ada Pembaruan",
    avocadoTreeDetail: "Detail Pohon Alpukat",
    avocadoTreeDetailHeader: "Detail Pohon Alpukat",
    avocadoTreeUpdates: "Pembaruan Pohon Alpukat",
    avocadoAddImages: "Tambahkan Gambar Baru",
    addNewTreeImage: "Tambahkan Gambar Pohon Baru",
    selectCountry: "Pilih Negara",
    allRegions: "Semua Wilayah",
    avocadoDetailCard: {
      clientTreeId: "ID Pohon",
      treeName: "Nama Pohon",
      latitude: "Lintang",
      longitude: "Bujur",
      altitude: "Ketinggian",
      zoneId: "ID Zona",
      createdAt: "Tanggal & Waktu Dibuat",
      plantationDate: "Tanggal & Waktu Ditanam",
      updatedAt: "Terakhir Diperbarui",
    },
    processingDialog: {
      modalHeader: "Menganalisis Status Deforestasi",
      modalDescription_first: "Menganalisis Status Deforestasi EUDR",
      modalDescription_second:
        "Lahan pertanian Anda sedang menjalani Analisis Deforestasi Otomatis. Anda akan diarahkan ke halaman daftar Laporan Due Diligence untuk melihat statusnya.",
    },

    downloadCSVFormat: "Unduh Format CSV",
    downloadXLSFormat: "Unduh Format XLS",
    downloadGeoJsonFormat: "Unduh Format GeoJSON",
    downloadXMLFormat: "Unduh Format XML",
    downloadGeoJSONFormat: "Unduh Format GeoJSON",
    downloadTopoJSONFormat: "Unduh Format TopoJSON",
    downloadGeoPackageFormat: "Unduh Format GeoPackage",
    downloadGeobufFormat: "Unduh Format Geobuf",

    fileName: "Nama File",
    importedOn: "Diimpor pada",
    status: "Status",
    actions: "Tindakan",
    action: "Tindakan",
    download: "Unduh",
    import: "Impor",
    history: "Riwayat",
  },
};
